var app = angular.module('leonardo');

var FolderRequirementsService = function(BaseRestService, Upload, $q, ConfigThemeService, RestangularProvider) {
  var service = new BaseRestService('document-requirements', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('document-requirements', false, function(file) {
      file.addRestangularMethod('dismiss', 'post', 'dismiss');
      return file;
    });
  });

  service.NOTICE_DAY_BEFORE = '1';
  service.NOTICE_WEEK_BEFORE = '2';
  service.NOTICE_MONTH_BEFORE = '3';
  service.NOTICE_MONTHS_BEFORE = '4';
  service.NOTICE_CUSTOM = '0';

  service.NOTICE_OPTIONS = [
    {id: service.NOTICE_DAY_BEFORE, name: '1 day before'},
    {id: service.NOTICE_WEEK_BEFORE, name: '1 week before'},
    {id: service.NOTICE_MONTH_BEFORE, name: '1 month before'},
    {id: service.NOTICE_MONTHS_BEFORE, name: '2 months before'},
    {id: service.NOTICE_CUSTOM, name: 'custom'}
  ];

  service.bulkObject = function(folder) {
    return {
      folder: folder,
      name: '',
      file: null,
      expiration: null,
      link: null,
      requirement: null
    };
  };

  service.post = function(data) {
    var d = {};
    angular.forEach(data, function(value, key) {
      if (value) d[key] = value;
    });
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/document-requirements/'),
      data: d
    });
  };

  service.put = function(id, data) {
    var defer = $q.defer();
    var d = {
      name: data.name,
      folder: data.folder,
      file: data.file
    };
    Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/document-requirements/' + id + '/'),
      data: d,
      method: 'PUT'
    }).then(function(item) {
      delete data['name'];
      delete data['folder'];
      delete data['file'];
      if (data.length == 0) {
        defer.resolve(item);
        return;
      }
      RestangularProvider.one('document-requirements', id).patch(data).then(function(item) {
        defer.resolve(item);
      }, function (error) {
        defer.reject(error);
      });
    }, function (error) {
      defer.reject(error);
    });
    return defer.promise;
  };

  service.getFileBlob = function (url, cb) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.addEventListener('load', function() {
        cb(xhr.response);
    });
    xhr.send();
  };

  service.blobToFile = function (blob, name) {
    blob.lastModifiedDate = new Date();
    blob.name = name;
    return blob;
  };

  service.getFileObject = function(filePathOrUrl, cb) {
    var array_url = filePathOrUrl.split('/');
    service.getFileBlob(filePathOrUrl, function (blob) {
      cb(service.blobToFile(blob, array_url[array_url.length-1]));
    });
  };

  return service;
};

app.factory('FolderRequirementsService', ['BaseRestService', 'Upload', '$q', 'ConfigThemeService', 'Restangular',
  FolderRequirementsService]);
